import React from 'react';
import axios2 from 'services/axios2';
import { ToastContainer, toast } from 'react-toastify';


import { withRouterJim } from "router/withRouterJim"; 
import NuAlert2 from 'components/NuAlert2';
import NuLoading from 'components/nubox/NuLoading';

import { Link } from "react-router-dom";
//import '../App.css';
import logo from 'assets/logo.png';
import { Button } from 'bootstrap/dist/js/bootstrap.bundle.min';
import { StrikethroughS } from '@material-ui/icons';



const initialForm1 = {
  idd:0,
  ope:'n',
  
  id_est:0,
  nro_doc:"",
  nomape_tmp:"",
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class EstudBuscar extends React.Component {

  myRef = React.createRef();//create ref
  nuRef = React.createRef();//create ref

  state = {
    data: [],/* lista  */
    cargando:false,
    form: {
      ci:"",      
    },
    form1: Object.assign({}, initialForm1),
    
  };

  //-----------------------------------------------

  //------------------------------------------------------
  componentDidMount() {
    console.log("componentDidMount citas");
    //--limpiamos el array de prueba
    this.setState({ data: [] });

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //this.setState({fechai: defaultValue}); 
    //let id_mate = this.props.store.materia.id_mate
    this.setState({ form: { ...this.state.form, 
                            fecha: defaultValue, 
    
                  } });

    
    //this.cargar_data();
    //this.cargar_citas();
    //this.fetchData(this.state.fechai);


  }

  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  onSubmitHandler= (event)=>{
    event.preventDefault();

    this.save();
  }
  //====================================================== 
  //-----------------------------------
  save =() =>{
    const user = this.props.store.user;
    //const id_paciente = this.props.store.paciente.id_paciente;

    let param = {...this.state.form,
                };
    console.log(param);

    this.setState({ cargando: true })
    axios2.post("estudbuscar_find", param)
    .then(res => {
        let res1 = res.data
        console.log(res.data);
        this.setState({ cargando: false })
        if(res1.exito === 1){ 
            //toast.success(res.data.men);   
            this.nuRef.current.show({'type':'info',"text":res1.men});         
            this.setState({form1: res1.form})
        }else{
            //toast.error(res.data.men);
            this.nuRef.current.show({'type':'error',"text":res1.men});
            this.setState({form1: Object.assign({}, initialForm1)})
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //-------------------------------------

  render() {
    let form = this.state.form
    let user = this.props.store.user
    return (
      <div>
        <ToastContainer />
        <div className="content">
          {
            //JSON.stringify(this.state.form1)
          }
          <form onSubmit={ this.onSubmitHandler}> 
            
            <legend></legend>


            <div className="row">
              <div className="col-md-12">
                <div className="box">
                  <div className="box-header with-border">
                    <h3 className="box-title"><strong>Busqueda de datos de estudiante</strong></h3>
                    <div className="box-tools pull-right">
                      <button className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i></button>

                      <button className="btn btn-box-tool" data-widget="remove"><i className="fa fa-times"></i></button>
                    </div>
                  </div>
                  {/* <!-- /.box-header --> */}
                  <div className="box-body">
                    <div className="row">
                      <div className="col-md-12">
                        {/* <!-----------Contenido------------->*/}


                        <div className="form-group ">
                          <label className="col-lg-2 control-label">CI:</label>
                          <div className="col-lg-10">
                            <input 
                                name="ci" 
                                type="text" 
                                className="form-control" 
                                placeholder="" 
                                value={this.state.form.ci }
                                onChange={this.handleChangeForm}  
                                />
                          </div>
                        </div>



                        <div className="form-group">
                          <div className="col-lg-10" align="left">
                            <button 
                              type="submit" 
                              className="btn btn-primary">Buscar</button>
                          </div>
                        </div>
                        {/* <!----------Fin Contenido---------------->*/}

                      </div>
                    </div>
                  </div>
                </div>{/* <!-- /.box -->*/}
              </div>
            </div> 
              
            
          </form>
          <NuLoading className="oso" show={this.state.cargando} text="Cargando..." />
          <br />
          <NuAlert2 ref={ this.nuRef } />
          
          <div className="box" style={{ width: 300 }}>
            <div className="box-header with-border">
              <h3 className="box-title">
                <strong>Resultados</strong>
              </h3>
              <div className="box-tools pull-right">
                <button className="btn btn-box-tool" data-widget="remove"><i className="fa fa-times"></i></button>
              </div>
            </div>
            
            <div className="box-body">
              <table>
                <tr>
                  <td><b>Cod.Est.</b></td>
                  <td>{this.state.form1.id_est}</td>
                </tr>
                <tr>
                  <td><b>Nro. doc</b></td>
                  <td>{this.state.form1.nro_doc}</td>
                </tr>
                <tr>
                  <td><b>Nombre</b></td>
                  <td>{this.state.form1.nomape_tmp}</td>
                </tr>
              </table>
              <Link to={`/kardex_est/${this.state.form1.id_est}` }
                    className='btn btn-default btn-sm'>Ver kardex</Link>
            </div>
          </div>

        </div>


      </div>
    );
  }
}

export default withRouterJim(EstudBuscar);